<div
class="toggle-collapse"
(click)="isCollapsed.toggle()"
[title]="isCollapsed.isTrue ? 'Expand' : 'Collapse'"
>
{{ isCollapsed.isTrue ? '▲' : '▼' }}
</div>
